export default {
  // Charge
  department: 'Department',
  monthUse: 'Usage Month',
  billingMonth: 'Billing Month',
  all: 'All',
  usePeriod: 'Usage Period',
  captionVAT: '* VAT included / Billing details are updated around the 5th of every month',
  year: 'Year',
  month: 'Month',
  totalCharge: 'Total Amount Billed',
  cost: 'Won',
  simpleCheck: 'Quick View of Usage Charges',
  captionDetail: '* See detailed table below',
  msgCost: '1. SMS Usage Fee',
  kakaoCost: '2. KakaoTalk Biz Message Usage Fee',
  fixedCost: '(Fixed Monthly Fee)',
  maintenanceCost: '4. Base Fee',
  useCost: '5. Usage Fee',
  vatCost: '6. VAT',
  monthTotalCost: '7. Total Charges This Month',
  alimtalk: 'FriendTalk',
  att: 'AlimTalk Text',
  ati: 'AlimTalk Image',
  ftt: 'FriendTalk Text',
  fti: 'FriendTalk Image',
  ftw: 'FriendTalk Wide Image',
  msgCaption: '* Total includes the base fee and transmission fee for each messaging service.',
  kakaoCaption: '* Includes the base and transmission fees for AlimTalk and FriendTalk.',
  basicCaption: '* Additional fees apply if base quota is exceeded.',
  sendCost: 'Transmission Fee',
  totalSendCost: 'Total Sent Messages',
  sendSuccess: 'Successful Messages',
  unitCost: 'Unit Price',
  price: 'Amount',
  print: 'Print',
  sms: 'SMS',
  lms: 'LMS',
  mms: 'MMS',
  '(1+2+3+4)': '(1+2+3+4)',
  '(5 * 10%)': '(5 * 10%)',
  '(5+6)': '(5+6)',
  yearUse: 'Usage Year',
  maintenanceCostCaption: '* It is basic charge for i2message service.',
  rejectPhoneMaintenanceCost: '3. 080 opt-out service fee',
  rejectPhoneMaintenanceCostCaption: '* This is the basic fee for using the 080 opt-out number service.',
};
